import {Icon, IconType, Text} from '@/ui-kits';
import { cn } from '@/utils/common_functions';
import React from 'react';

interface SpecialistStatisticsProps {
  value: string | number;
  icon: IconType;
  title: string;
  variant?: 'dark' | 'light'
}
export const SpecialistStatistics: React.FC<SpecialistStatisticsProps> = props => {
  const {value, icon, title, variant = 'light'} = props;
  return (
    <div
      style={{
        boxShadow: [
          '0px 1px 2px rgba(148, 148, 148, 0.10)',
          '0px 4px 4px rgba(148, 148, 148, 0.09)',
          '0px 10px 6px rgba(148, 148, 148, 0.05)',
          '0px 18px 7px rgba(148, 148, 148, 0.01)',
          '0px 28px 8px rgba(148, 148, 148, 0.00)',
        ].join(', '),
      }}
      className={cn(
        "bg-white relative overflow-hidden rounded-lg py-3 px-2 sm:py-4 sm:px-3 md:py-6 md:px-4 flex flex-col gap-2 sm:gap-3 md:gap-4 border border-ui_input_border_dark/40 min-w-0",
        variant === 'light' && "bg-gradient-to-r from-ui_sky_blue via-white to-ui_sky_blue",
        variant === 'dark'&& "bg-gradient-to-br from-ui_blue to-ui_blue_light",
      )}>
      <Text variant="subheadingMedium" className={cn("break-words !text-[10px] sm:!text-sm md:!text-base lg:!text-lg xl:!text-xl", variant === 'light' ? "gradient-text" : 'text-white')}>
        {title}
      </Text>
      <Text variant="heading" className={cn("!text-sm sm:!text-lg md:!text-3xl", variant === 'light' ? "text-ui_blue" : 'text-white')}>
        {value}
      </Text>
      <div className="flex-shrink-0 absolute -bottom-2 -right-2 rotate-[11deg]">
        <Icon type={icon} className="w-12 h-12 sm:w-16 sm:h-16 md:size-20" />
      </div>
    </div>
  );
};
